/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnershelp1Inputs */

const en_partnershelp1 = /** @type {(inputs: Partnershelp1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People and organisations who introduce businesses to Pulsify. Businesses that sign up through a partner link are assigned automatically for 60 days after the first visit; you can also assign them by hand.`)
};

const de_partnershelp1 = /** @type {(inputs: Partnershelp1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personen und Organisationen, die uns Betriebe vermitteln. Wer sich bis 60 Tage nach dem ersten Besuch über einen Partnerlink anmeldet, wird automatisch zugeordnet. Du kannst Betriebe auch selbst zuordnen.`)
};

/**
* | output |
* | --- |
* | "People and organisations who introduce businesses to Pulsify. Businesses that sign up through a partner link are assigned automatically for 60 days after the..." |
*
* @param {Partnershelp1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnershelp1 = /** @type {((inputs?: Partnershelp1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnershelp1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnershelp1(inputs)
	return de_partnershelp1(inputs)
});
export { partnershelp1 as "partnersHelp" }